import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { FileDownloaderProvider } from './../../providers/file-downloader/file-downloader';
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import saveAs from 'file-saver';
import { EmployeeLoanReportApi } from '../../shared/nestjs/gd-integrated/services/employee-loan-report.api';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { EventNameAnalytics } from '../../helpers/event-name-analytics';

@Injectable()
export class EmployeeLoanReportBloc {
    constructor(
        private platform: Platform,
        private fileDownloaderProvider: FileDownloaderProvider,
        private nestApiProvider: NestApiProvider,
        private employeeLoanReportApi: EmployeeLoanReportApi,
        private analyticsProvider: AnalyticsProvider
    ) { }

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Employee Loan Report')
        } else {
            saveAs(data, 'Employee Loan Report.xlsx')
        }
    }

    downloadExcel(data): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.employeeLoanReportApi.downloadExcel(data);
    }

    sendExcel(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                return this.employeeLoanReportApi.reportSendEmailExcel(data)
            })
    }

    type(): Observable<any> {
        return this.employeeLoanReportApi.type();
    }
}


// WEBPACK FOOTER //
// ./src/bloc/report/employee-loan-report.bloc.ts